<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-患者基础信息
-->

<template>
  <div class="body-info-entry">
    <div class="title">人体成分检测报告数据</div>
    <div class="card-list">
      <div v-for="item in datas" :key="item.type" class="card-box">
        <template v-if="item.type === '1'">
          <van-uploader :after-read="afterRead">
            <div class="uploader">
              <img class="report-img" v-if="loadStatus != 0" :src="url">

              <img v-if="loadStatus == 0" :src="item.icon" />
              <div v-if="loadStatus == 0" class="text">{{ item.text }}</div>
            </div>
          </van-uploader>
        </template>
        <template v-else>
          <img @click="selectType(item)" :src="item.icon">
          <div class="text">{{ item.text }}</div>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import clinicApi from '@/api/clinicApi'
import iconPhoto from '@/assets/clinic/icon-photo.png';
import iconFile from '@/assets/clinic/icon-file.png';
import iconGoto from '@/assets/clinic/icon-goto.png';
export default {
  name: 'BodyInfoEntry',

  data() {
    return {
      datas: [{
        icon: iconPhoto,
        text: '拍照识别',
        type: '1'
      }, {
        icon: iconFile,
        text: '手动填写',
        type: '2'
      }, {
        icon: iconGoto,
        text: '跳过',
        type: '3'
      }],
      loadStatus: 0,
      url: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    selectType(item) {
      this.$emit('next-step', { type: 'bodyInfoEntry', data: { bodyType: item.type } })
    },
    afterRead(file) {
      const formData = new FormData();
      formData.append('file', file.file);
      formData.append('code', 'lossadmin')
      clinicApi.uploadFile(formData, (res) => {
        if (res.success) {
          console.log("成功", res)
          this.loadStatus = 1
          this.url = res.data.url
          this.$emit('next-step', { type: 'bodyInfoEntry', data: { bodyType: '1', url: this.url } })
        } else {
          console.log("失败", res)
          this.loadStatus = -1
        }
      })

    }
  }
};
</script>

<style scoped>
.body-info-entry {
  width: 100%;
  padding: 2rem;
}

.title {
  height: 2.08rem;
  height: 1.83rem;
  font-weight: 500;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  text-align: left;
  font-style: normal;
  margin-bottom: 1.33rem;
}

.card-list .card-box {
  width: 100%;
  height: 10rem;
  background: #FFF9EE;
  border-radius: 0.5rem;
  border: 0.13rem dashed #FBB13D;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 2rem;
  margin-bottom: 2rem;
}

.card-list .card-box img {
  width: 4rem;
  height: 4rem;
  margin-bottom: 0.83rem;
}

.card-list .card-box .text {
  height: 1.83rem;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  letter-spacing: 1px;
}

.report-img {
  width: calc(100vw - 80px);
  height: 10.5rem;
}

.uploader {
  text-align: center;
}
</style>
